import Button from 'react-bootstrap/Button';

import { Icon } from "../../../react-entry";

import {
    getBaseUrlWrapper,
    getTextLegacy,
} from "../../common";

type EditionNotesProps = {
    data: IBookContract,
}

function EditionNotes(props: EditionNotesProps)
{
    const data = props.data;
    const baseUrl = getBaseUrlWrapper();

    // TODO: the interface is something else/other than IBookContract
    // @ts-ignore
    const bookId = data.bookId;
    const openEditionUrl = `${baseUrl}BookReader/BookReader/Listing?bookId=${bookId}`;

    const openEditionLabel = getTextLegacy('OpenEdition', 'PluginsJs');

    // TODO: authors
    const heading = <h1>{data.title}</h1>;
    // TODO: editors

    //  XXX: copied from EntryButtons (including the declarations above)
    const openEditionButton = <Button
        href={openEditionUrl}
        target="_blank"
        variant="default" // TODO: primary
        className="me-1" // margin left == “end”
        // NOPE/DONE: key="automate"
    >
        <Icon
            iconName="Book"
            className="me-2"
        />
        {openEditionLabel}
    </Button>

    return <>
        {heading}

        {openEditionButton}
    </>;
}

export { EditionNotes };
